<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col sm="12">
          <b-button variant="link" @click="go_list()" class="float-right px-0">빠른 설정 나가기</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <!-- progress bar -->
        <b-col sm="1"></b-col>
        <b-col sm="10">
          <p>
            <StepProgress active-color="black" :steps="steps['KO']" :current-step="status.step" />
          </p>
        </b-col>
        <b-col sm="1"></b-col>
      </b-row>
      <hr>
      <b-row class="step_box mb-4" v-if="status.step != 1">
        <b-col>
          {{steps['KO'][status.step]}}
        </b-col>
      </b-row>
      <b-row class="step_box mb-4" v-else>
        <b-col>
          {{steps['KO'][status.step]}}
          <p>
          <h4>탐색을 위한 새 정책 만들기</h4>
          <small>
            이 단계는 "빠른 탐색" 정책으로 자동 생성합니다.
            추후 새 정책 또는 현 정책을 편집하거나 구성하고 제거할 수 있습니다.
          </small>
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <transition-group name="slide-fade">
            <!-- first -->
            <b-form-group v-if="status.step == 0" v-bind:key="0">
              <b-input-group class="text-center">
                <b-input-group-prepend>
                  <b-input-group-append is-text>
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox" checked="">
                      <div class="checkbox-animate">
                        <small style="margin-top:2px;" class="checkbox-off">HTTP</small>
                        <small style="margin-top:2px;" class="checkbox-on">HTTPS</small>
                      </div>
                    </div>
                  </b-input-group-append>
                  <b-input-group-text>
                    FQDN
                    <a class="ml-2" href="javascript:void(0);" v-b-tooltip.hover.hover
                      title="www.f1security.co.kr, img.f1security.co.kr, ftp.f1security.co.kr => FQDN is f1security.co.kr">
                      <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                    </a>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn"
                  placeholder="FQDN (ex : company.com)" v-model="model.fqdn" @keypress.enter="next()"></b-form-input>
              </b-input-group>
            </b-form-group>
            <!-- seconed -->
            <b-form-group v-if="status.step == 1" v-bind:key="1">
              <b-row>
                <b-col>
                  <strong class="d-inline-block float-left">정책 : {{policy_description}}</strong>
                  <b-button class="d-inline-block float-right" v-if="policy_has" variant="link"
                    @click="modal_policy= true">기존 정책 사용</b-button>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  검사 사이트에서 확인할 총 페이지 수입니다.
                  입력한 번호에 도달하면 검사를 종료합니다.
                  해당 설정은 1 부터 라이센스 제한 범위 내에서 자유롭게 지정할 수 있습니다.`">
                  <span class="col-form-label">
                    최대 탐색 페이지
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10"
                    :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
                </b-col>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  페이지 내에서 탐색하려면 최대 하위 링크를 입력합니다.
                  초과 링크는 무시하십시오.
                  일반적으로 한 페이지에 너무 많은 링크가 있는 경우, 다른 페이지로 이동하기 전에 최대 탐색 페이지에 도달하여 균형 있게 선택하지 못하도록 할 수 있습니다.
                  Quick Setup의 기본값은 ${policy.links} 입니다.`">
                  <span class="col-form-label">
                    서브 페이지 링크
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1"
                    :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  페이지 내에서 탐색하려면 최대 하위 링크를 입력합니다.
                  초과 링크는 무시하십시오.
                  일반적으로 한 페이지에 너무 많은 링크가 있는 경우, 다른 페이지로 이동하기 전에 최대 탐색 페이지에 도달하여 균형 있게 선택하지 못하도록 할 수 있습니다.
                  Quick Setup의 기본값은 ${policy.links} 입니다.`">
                  <span class="col-form-label">
                    최대 탐색 페이지
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1"
                    :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                </b-col>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  페이지 로딩 대기 시간입니다.
                  1 - 30 범위 내에서 지정할 수 있습니다.
                  빠른 설정의 기본값은 ${policy.timeout} 입니다.`">
                  <span class="col-form-label">
                    타임아웃(초)
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1"
                    :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  새 페이지로 이동하기 전에 기다려야 할 시간입니다.
                  1~10,000 범위 내에서 지정할 수 있습니다..
                  빠른 설정의 기본값은 ${policy.delay} 입니다`">
                  <span class="col-form-label">
                    점검 속도(밀리초)
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0"
                    :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>
            </b-form-group>
            <!-- final -->
            <b-form-group v-if="status.step == 2" v-bind:key="2">
              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    * 사이트 등록이 이루어지고 검색이 시작되면 점검이 시작됩니다.
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree1"
                    @change="(x) => model.is_start = x && status.agree2 && status.agree3 && status.agree4 ">
                    확인 후, 동의합니다.
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    * 트래픽은 실제 웹 사이트에서 생성됩니다.
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree2"
                    @change="(x) => model.is_start = status.agree1 && x && status.agree3 && status.agree4 ">
                    확인 후, 동의합니다.
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    * 자세한 사항은 이용 약관을 참고해주세요
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree3"
                    @change="(x) => model.is_start = status.agree1 && status.agree2 && x && status.agree4 ">
                    확인 후, 동의합니다.
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <strong class="text-danger">매일 오전 {{status.interval}} 시에 점검하겠습니다</strong>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree4"
                    @change="(x) => model.is_start = status.agree1 && status.agree2 && status.agree3 && x ">
                    확인 후, 동의합니다.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <hr>
              <b-row class="text-center">
                <b-col md="12">
                  <b-form-checkbox class="mr-n2 mb-n1"
                    @change="(x) => { status.agree1 = x; status.agree2 = x; status.agree3 = x; status.agree4 = x }"
                    v-model="model.is_start" ref="agreement">
                    <strong>이용 약관을 확인하고, 동의힙니다</strong>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>

            <!-- final -->
            <b-form-group v-if="status.step == 3" v-bind:key="2">
              <center>
                <p>빠른 설정이 완료 되었습니다</p>
                <p>곧 점검이 시작됩니다</p>
                <p></p>
                <b-button variant="link" @click="go_site()" class="px-0">등록된 사이트 설정을 변경 </b-button>
                or
                <b-button variant="link" @click="go_policy()" class="px-0">점검 정책 수정 </b-button>
              </center>
            </b-form-group>
          </transition-group>
        </b-col>
      </b-row>
      <hr>
      <!-- 마지막에는 이전이 없어야 함 -->
      <b-row>
        <b-col>
          <b-button v-if="status.step > 0 && status.step < steps['KO'].length - 1" block size="sm" variant="info"
            @click="prev()"> 이전 </b-button>
          <!-- <b-button v-else  block size="sm" variant="success" @click="go_list">Complete</b-button> -->
        </b-col>
        <b-col>
          <b-button v-if="status.step < steps['KO'].length - 1" block size="sm" variant="primary" @click="next()">다음
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <link rel="stylesheet" href="custom/wmds.site.quick.setup.css">
    <!-- delete modal -->
    <b-modal size="xl" title="Choice Policy" class="modal-primary" v-model="modal_policy" @ok="modal_policy = false"
      header-bg-variant="primary" ok-variant="primary">
      <PolicyList :use_view="false"
        @selected="x => { policy = Object.assign({}, policy, x.policy); policy_description = x.description; modal_policy = false; policy_selected = true; status.policy_id = x.id }" />
    </b-modal>
  </div>
</template>
<style>
  .step-progress__step-label {
    font-size: 1.3em !important;
  }

  @media (max-width: 1200px) {
    .step-progress__step-label {
      font-size: 0.9em !important;
    }
  }

  @media (max-width: 767px) {
    .step-progress__step-label {
      font-size: 0.6em !important;
    }
  }
</style>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
